import styled from "styled-components";
import compose_logo from "../../imgs/compose_logo_half.svg";
import ImageButton from "../Buttons/ImageButton";
import Column from "../Column/Column";
import Row from "../Row/Row";
import Text from "../Text/Text";
import discord_icon from "./imgs/discord_icon.png";
import instagram_icon from "./imgs/instagram_icon.png";
import twitter_icon from "./imgs/twitter_icon.png";

const SubscribeColumn = styled(Column)`
  flex: 1;
  @media screen and (max-width: 650px) {
    max-width: 100%;
    width: 100%;
    margin-inline: 20%;
  }
`;

const ConnectWithUsColumn = styled(Column)`
  flex: 1;
  text-align: center;
  align-items: center;

  @media screen and (max-width: 650px) {
    width: 100%;
    text-align: center;
    margin-inline: 20%;
  }
`;

const AboutUsColumn = styled(Column)`
  flex: 1;
  max-width: 50%;

  @media screen and (max-width: 650px) {
    max-width: 100%;
    width: 100%;
    margin-inline: 10%;
    text-align: center;
  }
`;

const AboutUsText = styled(Text)`
  margin-left: 5%;

  @media screen and (max-width: 650px) {
    margin-left: 0%;
    text-align: center;
    max-width: 100%;
  }
`;

const LongAboutUsText = styled(AboutUsText)`
  max-width: 80%;

  @media screen and (max-width: 650px) {
    margin-left: 0%;
    text-align: center;
    max-width: 100%;
  }
`;

const SubscribeText = styled(Text)`
  margin-left: 20%;

  @media screen and (max-width: 650px) {
    margin-left: 0%;
    text-align: center;
    max-width: 100%;
  }
`;

const IconsRow = styled(Row)`
  width: 100%;
  justify-content: space-evenly;
  flex: 1;

  @media screen and (max-width: 650px) {
    width: 100%;

    flex: 0;
    padding-inline: 20%;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #000000;
  background-size: cover;
  padding-top: 5%;
  padding-bottom: 5%;
  flex-wrap: wrap;
`;

const FooterSectionRow = styled(Row)`
  justify-content: space-evenly;
  padding-top: 2rem;
  align-items: baseline;
  flex-wrap: wrap;

  @media screen and (max-width: 650px) {
    flex-wrap: wrap;
  }
`;

const Footer = () => {
  const onInstagramClick = () => {
    window.location.assign("https://www.instagram.com/composenft/");
  };
  const onTwitterClick = () => {
    window.location.assign("https://twitter.com/composenft_");
  };
  const onDiscordClick = () => {
    window.location.assign("https://discord.com/invite/zWejyUye");
  };
  return (
    <FooterSection>
      <a href="/">
        <img style={{ width: "300px" }} src={compose_logo} alt="" />
      </a>
      <FooterSectionRow>
        <AboutUsColumn>
          <AboutUsText bold={true} size={"1.25rem"}>
            About Us
          </AboutUsText>
          <LongAboutUsText>
            At ComposeNFT we are reimagining the way music is shared, created
            and consumed using Web3. Our goal is to empower the common musician
            and their fan bases around the globe.
          </LongAboutUsText>
        </AboutUsColumn>
        <ConnectWithUsColumn>
          <Text bold={true} size={"1.25rem"}>
            Connect With Us
          </Text>
          <IconsRow>
            <ImageButton bg={instagram_icon} onClick={onInstagramClick} />
            <ImageButton bg={twitter_icon} onClick={onTwitterClick} />
            <ImageButton bg={discord_icon} onClick={onDiscordClick} />
          </IconsRow>
          <Text style={{ opacity: "0.3", marginTop: "10%" }}>
            Copyright protected by ComposeNFT
          </Text>
        </ConnectWithUsColumn>
        <SubscribeColumn>
          <SubscribeText bold={true} size={"1.25rem"}>
            Contact Us
          </SubscribeText>
          <SubscribeText>
            Please reach out to us at: artistrelations@composenft.io
          </SubscribeText>
        </SubscribeColumn>
      </FooterSectionRow>
    </FooterSection>
  );
};

export default Footer;
